// The classes a theme gives the customer's popup after Submit (CustomerContactPopup, CustomerConfirmationPopup), so it
// matches the form behind it: its card colours (_customer_popup_theme.scss) and its own label, input and submit button,
// which a theme whose classes are named otherwise passes in.
const customerPopupClassNamesFor = (styles, { label = styles.label, input = styles.input, button = styles.submitButton } = {}) => ({
  card: styles.customerPopupCard,
  text: styles.customerPopupText,
  label,
  input,
  button,
  link: styles.customerPopupLink,
  error: styles.customerPopupError,
  notice: styles.customerPopupNotice,
});

export const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

export default customerPopupClassNamesFor;
